/**
 * Testimonial-related actions
 */
(function ($) {
    'use strict';

    $(function () {
        var model_testimonial = 'testimonial';
        var a_ajax = new AwesomeAjax('aetfree');
        var aet_ajax = new AET_Ajax();
        var aet_animation = new AET_Animation();

        // Add New Testimonial Button
        $('[data-action="add-testimonial"]').on('click', function () {
            var args = {
                id: 'aet',
                item_id: '#',
                parent: '#wpcontent',
                html: '#testimonial-add-wrap',
                model_name: model_testimonial,
                direction: 'right',
                width: '67%',
                load_model: testimonial_load_model,
                callback_open: edit_testimonial_open_callback,
                callback_close: edit_testimonial_close_callback
            };
            window.panel = new AwesomePanel(args);
            panel.init();
        });

        function testimonial_load_model(id, model_name) {
            return aet_ajax.load_model(id, model_name).then(function () { // wait until backbone model is loaded
                return aet_ajax.init_categories().then(function () { // wait until all possible departments is loaded
                    var dfd = $.Deferred();
                    var dfd1 = $.Deferred();

                    window.selectize_instance = $('[name="testimonial_category"]', aet_panel).selectize({
                        plugins: ['restore_on_backspace', 'remove_button'],
                        delimiter: ',',
                        addPrecedence: false,
                        options: aet_testimonials_taxonomy_terms || [],
                        items: model.get('category') || [],
                        valueField: 'name',
                        labelField: 'name',
                        searchField: 'name',
                        preload: true,

                        onInitialize: function () {
                            dfd1.resolve('selectize init'); // selectize is initialized => resolve promise
                        },

                        create: function (input) {
                            return {
                                value: input,
                                name: input
                            };
                        },

                        render: {
                            option: function (item, escape) {
                                return '<div>' + escape(item.name) + '</div>';
                            }
                        }
                    });

                    aet_ajax.fill_testimonial_full_text(aet_panel, 'testimonial_full_text', model.get('full_text'));

                    $.when(dfd1, testimonial_full_text_dfd).done(function (v1, v2) {
                        dfd.resolve('both init');
                    });

                    return dfd;
                });
            });
        }

        function edit_testimonial_open_callback() {
            $('#testimonial-form-foto-remove', aet_panel).hide(); // hide "remove photo" button

            window.preview = new AwesomeTestimonial();
            preview.init();
        }

        function edit_testimonial_close_callback() {
            if (
                typeof (selectize_instance) != 'undefined' &&
                typeof (selectize_instance[0]) != 'undefined' &&
                typeof (selectize_instance[0].selectize) != 'undefined'
            ){
                selectize_instance[0].selectize.destroy();
            }
            if(typeof preview != 'undefined'){
                preview.destroy();
            }
            if(typeof tinyMCEPreInit !== 'indefined'){
                tinyMCEPreInit.mceInit = {}
                tinyMCEPreInit.qtInit = {}
            }
            $('div.testimonial_full_text').html('');

        }

        // Edit Testimonial
        $('[data-action="edit-testimonial"]').on('click', function (e) {
            var id = parseInt($(this).attr('testimonial-id'));

            // if we hit on testimonial but not Delete button
            if (
                !$(e.target).parents('button').hasClass('delete-testimonial') &&
                !$(e.target).parents('button').hasClass('publish-testimonial')&&
                !$(e.target).hasClass('delete-testimonial') &&
                !$(e.target).hasClass('publish-testimonial')
            ) {

                var args = {
                    id: 'aet',
                    item_id: id,
                    parent: '#wpcontent',
                    html: '#testimonial-edit-wrap',
                    model_name: model_testimonial,
                    direction: 'right',
                    width: '67%',
                    load_model: testimonial_load_model,
                    callback_open: edit_testimonial_open_callback,
                    callback_close: edit_testimonial_close_callback
                };

                window.panel = new AwesomePanel(args);
                panel.init();

            }
        });

        function set_testimonial_photo_callback(img) {
            $('#testimonials-list li[testimonial-id="' + model.get('id') + '"] .foto').html(img);
        }

        function update_testimonial_card() {
            var post_id = model.get('id');
            aet_ajax.set_testimonial_photo(post_id, 'a-small', set_testimonial_photo_callback);
            $('#testimonials-list li[testimonial-id="' + post_id + '"] span.name').html(model.escape('name'));
            $('#testimonials-list li[testimonial-id="' + post_id + '"] span.short_text').html(model.escape('short_text'));
            $('#testimonials-list li[testimonial-id="' + post_id + '"] span.rating .rating-fill').css('width', model.escape('custom_fields.rating') + '%');
        }

        // Bind AJAX call on Form Submit Button
        $('[data-action="save-testimonial"]').on('click', function () {
            var form = $('[data-type="form"]', aet_panel);
            var model = $(form).attr('data-model');
            var $alert = form.find('[data-type="testimonial-alert"]');
            $alert.attr('class', 'alert').hide();

            window.panel.hide_content();
            window.panel.animation_start(); // show animation

            a_ajax.ajax({
                action: 'aetfree_update_or_new_' + model,
                data: {
                    //data: form.serialize(),
                    data: window.model.toJSON()
                },
                success_handler: function (data) {
                    window.model.set('id', data);
                    update_testimonial_card();
                    window.panel.show_content();
                    window.panel.animation_end();
                },
                success_error_handler: function (errors) {
                    var html = '';
                    $.each(errors, function (index, value) {
                        html += '<p>';
                        html += value.message;
                        html += '</p>';
                    });
                    $alert.addClass('alert-warning').show().html(html);
                    window.panel.show_content();
                    window.panel.animation_end();
                },
                error_handler: function () {
                    $alert.addClass('alert-warning').show().html(data);
                    window.panel.show_content();
                    window.panel.animation_end();
                }
            });
        });

        // Delete Testimonial
        $('[data-action="delete-testimonial"]').on('click', function () {
            var $parent = $(this).parents('li');
            var id = parseInt($parent.attr('testimonial-id'));
            var model_name = model_testimonial;

            if (confirm('You really want to delete testimonial?')) {
                a_ajax.delete_model(id, model_name).then(function () {
                    aet_animation.delete_model($parent, model_name);
                });
            }
        });

    });
})(jQuery);